/* Shopify continues to own every consent decision. No cookies are read or written here. */
(() => {
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-cookie-preferences]');
    if (!link) return;
    if (window.privacyBanner?.showPreferences) {
      event.preventDefault();
      Promise.resolve(window.privacyBanner.showPreferences()).catch(() => { location.href = link.href; });
    }
    // Without the loaded banner API, the genuine Shopify policies anchor is the fallback.
  });
  let banner, resizeObserver, bannerObserver, pending = false;
  function measure() {
    pending = false;
    const next = document.getElementById('shopify-pc__banner');
    if (next !== banner) {
      resizeObserver?.disconnect(); bannerObserver?.disconnect(); banner = next;
      if (banner) { bannerObserver = new MutationObserver(schedule); bannerObserver.observe(banner, {attributes:true,childList:true,subtree:true,attributeFilter:['class','style','hidden']}); }
      if (banner && window.ResizeObserver) { resizeObserver = new ResizeObserver(schedule); resizeObserver.observe(banner); }
    }
    const rect = banner?.getBoundingClientRect();
    const visible = rect && rect.height > 0 && getComputedStyle(banner).visibility !== 'hidden' && getComputedStyle(banner).display !== 'none';
    const height = visible && matchMedia('(max-width:700px)').matches ? Math.ceil(rect.height + 24) : 0;
    const value = height + 'px';
    if (document.documentElement.style.getPropertyValue('--ragga-consent-height') !== value) document.documentElement.style.setProperty('--ragga-consent-height', value);
  }
  function schedule() { if (!pending) { pending = true; requestAnimationFrame(measure); } }
  new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes, ...record.removedNodes].some(node => node.nodeType === 1 && (node.id === 'shopify-pc__banner' || node.querySelector?.('#shopify-pc__banner'))))) schedule();
  }).observe(document.body, {childList:true,subtree:true});
  window.addEventListener('resize', schedule);
  document.addEventListener('visitorConsentCollected', schedule);
  measure();
})();
